import { render, staticRenderFns } from "./ChoiceNutritionModal.vue?vue&type=template&id=64bf9eba&scoped=true"
import script from "./ChoiceNutritionModal.vue?vue&type=script&lang=js"
export * from "./ChoiceNutritionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bf9eba",
  null
  
)

export default component.exports